import {getYieldDetails, updateYieldDetails} from './digidiary.service';
import {getUserIDState, handleAlert} from './sagaHelper';

import {
  DD_UPDATE_CROP_STATE,
  DIGIDIARY_ADD_YIELD,
  DIGIDIARY_GET_YIELD,
  DIGIDIARY_SET_LOADER,
  POP_DIGIDIARY_VIEW,
  PUSH_DIGIDIARY_VIEW,
} from '../actions';

import {select, put, call, takeEvery} from 'redux-saga/effects';

export function* addYieldData({data}) {
  let flag = true;
  yield put({type: DIGIDIARY_SET_LOADER, flag});
  let userId = yield select(getUserIDState);

  let payload = {
    cropId: data.cropId,
    yieldQuantity: data.quantityNum,
    yieldUnit: data.unit,
  };
  const response = yield updateYieldDetails(userId, payload);
  flag = false;
  yield put({type: DIGIDIARY_SET_LOADER, flag});
  if (response.statusCode && response.statusCode === 200) {
    const dataObj = {
      crops: [response.data?.Attributes],
    };
    yield put({type: DD_UPDATE_CROP_STATE, dataObj});
    let newView = 'totalIncome';
    yield put({type: POP_DIGIDIARY_VIEW});
    yield put({type: PUSH_DIGIDIARY_VIEW, newView});
    yield call(handleAlert, {variant: 'success', type: 'addYieldSuccess'});
  } else {
    yield call(handleAlert, {variant: 'error', type: 'alertError'});
  }
}

export function* getYieldData() {
  let flag = true;
  yield put({type: DIGIDIARY_SET_LOADER, flag});
  let userId = yield select(getUserIDState);
  const response = yield getYieldDetails(userId);
  flag = false;
  yield put({type: DIGIDIARY_SET_LOADER, flag});
  if (response.statusCode && response.statusCode === 200) {
    let newView =
      response.data && response.data[0].yieldQuantity
        ? 'totalIncome'
        : 'addYield';
    yield put({type: PUSH_DIGIDIARY_VIEW, newView});
  }
}

export function* addYieldSaga() {
  yield takeEvery(DIGIDIARY_ADD_YIELD, addYieldData);
  yield takeEvery(DIGIDIARY_GET_YIELD, getYieldData);
}
